@if (dsHighlight) {
    <ds-card
        [ngClass]="isStaticPromotion ? 'meta-data-static-promotion' : 'meta-data-static'"
        [elevated]="dsComponents?.dsCardStatic?.elevated"
        [variant]="dsComponents?.dsCardStatic?.variant">
        <ng-container *ngTemplateOutlet="detailmetadata"></ng-container>
    </ds-card>
} @else {
    <ng-container *ngTemplateOutlet="detailmetadata"></ng-container>
}

<ng-template #detailmetadata>
    <div [ngClass]="{ 'bonus-card-details plus-time-to-use': filteredMetaDataList?.length > 0 }">
        <ng-content select="[registerOptinCta]"></ng-content>
        <ng-content select="[detailsPageDateTime]"></ng-content>
        @for (item of metaDataList; track item; let i = $index) {
            <div class="bonus-field border-0">
                <div class="bonus-field-wrapper">
                    @if (item?.description && item?.title) {
                        <span class="bonus-card-details-heading" [vnDynamicHtml]="item?.title"></span>
                    }
                    @if (item?.isToolTipWithTitle) {
                        <span>
                            @if (item?.toolTipType == 'popper') {
                                <i
                                    class="ui-icon theme-info-i popper-icon"
                                    [closeOnInteraction]="true"
                                    [closeOutsideViewport]="true"
                                    [closeOnScroll]="true"
                                    [dsTooltipTriggerFor]="popperContent"
                                    arrowPosition="middle"
                                    position="bottom"></i>
                                <ng-template #popperContent>
                                    <ds-tooltip-content
                                        variant="{{ dsComponents?.dsTooltip?.variant }}"
                                        inverse="{{ dsComponents?.dsTooltip?.inverse }}">
                                        <button
                                            slot="close"
                                            ds-button-icon
                                            size="small"
                                            variant="flat"
                                            kind="{{ dsComponents?.dsTooltip?.iconButtonKind }}"
                                            inverse="{{ dsComponents?.dsTooltip?.iconButtonInverse }}">
                                            <vn-icon size="14" name="theme-ex"></vn-icon>
                                        </button>
                                        <div slot="description">{{ item?.toolTip }}</div>
                                    </ds-tooltip-content>
                                </ng-template>
                            }
                            @if (item?.toolTipType == 'simple') {
                                <i class="ui-icon theme-info-i" title="{{ item.toolTip }}"></i>
                            }
                        </span>
                    }
                    <div class="bonus-card-details-value">
                        <span [vnDynamicHtml]="item.description"></span>
                        @if (i === bonusExcludeGamesIndex) {
                            <ng-content select="[excludeGames]"></ng-content>
                        }
                        @if (!item?.isToolTipWithTitle) {
                            <span>
                                @if (item?.toolTipType == 'popper') {
                                    <i
                                        class="ui-icon theme-info-i popper-icon"
                                        [closeOnInteraction]="true"
                                        [closeOutsideViewport]="true"
                                        [closeOnScroll]="true"
                                        [dsTooltipTriggerFor]="popperContent"
                                        arrowPosition="middle"
                                        position="bottom"></i>
                                    <ng-template #popperContent>
                                        <ds-tooltip-content
                                            variant="{{ dsComponents?.dsTooltip?.variant }}"
                                            inverse="{{ dsComponents?.dsTooltip?.inverse }}">
                                            <button
                                                slot="close"
                                                ds-button-icon
                                                size="small"
                                                variant="flat"
                                                kind="{{ dsComponents?.dsTooltip?.iconButtonKind }}"
                                                inverse="{{ dsComponents?.dsTooltip?.iconButtonInverse }}">
                                                <vn-icon size="14" name="theme-ex"></vn-icon>
                                            </button>
                                            <div slot="description">{{ item?.toolTip }}</div>
                                        </ds-tooltip-content>
                                    </ng-template>
                                }
                                @if (item?.toolTipType == 'simple') {
                                    <i class="ui-icon theme-info-i" title="{{ item?.toolTip }}"></i>
                                }
                            </span>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
</ng-template>
